import Box from '@mui/material/Box';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ReactNode } from 'react';

import { layoutColSortableId } from 'src/helpers/pageDocumentUtils';

interface SortableColumnShellProps {
  columnsBlockId: string;
  columnIndex: number;
  showColumnDrag: boolean;
  children: (dragHandle: {
    attributes: import('@dnd-kit/core').DraggableAttributes;
    listeners: import('@dnd-kit/core/dist/hooks/utilities').SyntheticListenerMap | undefined;
  }) => ReactNode;
}

export default function SortableColumnShell({
  columnsBlockId,
  columnIndex,
  showColumnDrag,
  children,
}: SortableColumnShellProps) {
  const sortableId = layoutColSortableId(columnsBlockId, columnIndex);
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: sortableId,
    disabled: !showColumnDrag,
  });

  const style = {
    transform: isDragging ? undefined : CSS.Transform.toString(transform),
    transition: isDragging ? undefined : transition,
    opacity: isDragging ? 0.5 : 1,
    flex: 1,
    minWidth: 0,
  };

  return (
    <Box ref={setNodeRef} style={style} data-testid={`sortable-column-shell-${columnIndex}`}>
      {children({ attributes, listeners })}
    </Box>
  );
}
